import React, { useState, useEffect, useRef } from 'react';
import axios from '../api/axios';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useNavigate } from 'react-router-dom';
import { useSignIn } from 'react-auth-kit';
import { useIsAuthenticated } from 'react-auth-kit';
import { Typography, Box, Button, Grid, Select, MenuItem, FormControl,TextField } from '@mui/material';
import { styled } from '@mui/system';
import Navbarconnexion from '../components/Navbarconnexion';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const CustomTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-root': {
    backgroundColor: '#D9D9D9',
    borderRadius: '20px',
    border: 'none',
    transition: 'border 0.1s',
    '&:hover': {
      backgroundColor: '#D9D9D9',
    },
    '&.Mui-focused': {
      backgroundColor: '#D9D9D9',
      border: '3px solid black',
    },
    '& input': {
      fontWeight: 'bold',
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
}));

const CustomFormControl = styled(FormControl)(({ theme }) => ({
  '& .MuiInputBase-root': {
    backgroundColor: '#D9D9D9',
    borderRadius: '20px',
    border: 'none',
    transition: 'border 0.1s',
    '&:hover': {
      backgroundColor: '#D9D9D9',
    },
    '&.Mui-focused': {
      backgroundColor: '#D9D9D9',
      border: '3px solid black',
    },
    '& input': {
      fontWeight: 'bold',
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
}));

function Signup() {
  const navigate = useNavigate();
  const signIn = useSignIn();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (isAuthenticated()) {
      navigate('/');
    }
  }, [isAuthenticated]);

  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState("error");
  const [errMsg, setErrMsg] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [firstname, setFirstName] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [telephone, setTelephone] = useState('');
  const [profile, setProfil] = useState('');
  const [format, setFormat] = useState('');
  const [is_admin, setIsAdmin] = useState('');
  const [sport, setSport] = useState('');
  const [sport2, setSport2] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const emailTimeoutRef = useRef(null);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      setIsAdmin(0);

      if (password !== confirmPassword) {
        setErrMsg('Les mots de passe ne correspondent pas');
        setOpen(true);
        return;
      }

      setErrMsg('Inscription Réussie');
      setSeverity("success");
      setOpen(true);
      const response = await axios.post('/signup/signup', {
        firstname,
        name,
        telephone,
        email,
        password,
        profile,
        format,
        sport,
        sport2,
        is_admin
      }, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content, Accept, Content-Type, Authorization',
        }
      });

      if (response.status === 200) {
        signIn({
          token: response.data.token,
          expiresIn: 60,
          tokenType: "Bearer",
          authState: { username: username },
        });
      }
    } catch (error) {
      if (error.response.status === 404) {
        setErrMsg('Utilisateur non trouvé');
      } else if (error.response.status === 401) {
        setErrMsg('Mauvais mot de passe');
      }
      setOpen(true);
    }
  };

  const handleSelectChange = (e) => {
    setProfil(e.target.value);
  };

  const handlePhoneChange = (e) => {
    const inputPhoneNumber = e.target.value;
    const phoneRegex = /^[0-9\s\-()]+$/;

    if (phoneRegex.test(inputPhoneNumber)) {
      setTelephone(inputPhoneNumber);
      setOpen(false);
    } else {
      setErrMsg('Le numéro de téléphone n\'est pas valide.');
      setOpen(true);
    }
  };

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleFirstName = (e) => {
    setFirstName(e.target.value);
  };

  const handleEmailChange = (e) => {
    const inputEmail = e.target.value;

    if (emailTimeoutRef.current) {
      clearTimeout(emailTimeoutRef.current);
    }

    emailTimeoutRef.current = setTimeout(() => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (emailRegex.test(inputEmail)) {
        setEmail(inputEmail);
        setOpen(false);
      } else {
        setErrMsg('L\'adresse e-mail n\'est pas valide.');
        setOpen(true);
      }
    }, 1000);

    setEmail(inputEmail);
  };

  const handlePassword = (e) => {
    setPassword(e.target.value);
  };

  const handleConfirmPassword = (e) => {
    setConfirmPassword(e.target.value);
  };

  const handleFormatChange = (e) => {
    setFormat(e.target.value);
  };

  const handleSportChange = (e) => {
    setSport(e.target.value);
  };

  const handleSport2Change = (e) => {
    setSport2(e.target.value);
  };

  return (
    <Box sx={{
      height:'140vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
      backgroundColor: 'rgba(58, 29, 29, 0.1)',
      backgroundImage: `
        repeating-linear-gradient(to right,
          rgba(0, 0, 0, 0) 0%, 
          rgba(0, 0, 0, 0) calc(50% - 1px), 
          #FFFFFF calc(50% - 1px), #FFFFFF calc(50% + 1px),
          rgba(0, 0, 0, 0) calc(50% + 1px), rgba(0, 0, 0, 0) 100%
        )
      `,
      backgroundSize: 'calc(100% / 5) 100%',
    }}>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
          {errMsg}
        </Alert>
      </Snackbar>
      <Navbarconnexion/>
      <Box sx={{marginTop:'3rem'}}>
        <form onSubmit={handleSubmit}>
          <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <Typography variant="h3" sx={{ mb: 2, fontWeight: 'bold', textAlign: 'center',fontSize:{xs:'2rem',md:'3rem'},marginTop:{xs:'4rem',md:'3rem'} }}>Inscription</Typography>
          <Grid container justifyContent="center" alignItems="center" spacing={2} wrap='wrap'>
              <Grid item xs={4}>
                <Typography variant='body2' sx={{ margin: '1rem', fontWeight: 'bold' }}>PRENOM</Typography>
                <CustomTextField
                  fullWidth
                  value={firstname}
                  onChange={handleFirstName}
                  required
                />
              </Grid>
              <Grid item xs={0.5}>
              </Grid>
              <Grid item xs={4}>
                <Typography variant='body2' sx={{ margin: '1rem', fontWeight: 'bold' }}>NOM</Typography>
                <CustomTextField
                  fullWidth
                  value={name}
                  onChange={handleNameChange}
                  required
                />
              </Grid>
              <Grid item xs={4}>
                <Typography variant='body2' sx={{ margin: '1rem', fontWeight: 'bold' }}>NUMERO DE TELEPHONE</Typography>
                <CustomTextField
                  fullWidth
                  value={telephone}
                  onChange={handlePhoneChange}
                  required
                />
              </Grid>
              <Grid item xs={0.5}>
              </Grid>
              <Grid item xs={4}>
                <Typography variant='body2' sx={{ margin: '1rem', fontWeight: 'bold' }}>ADDRESSE MAIL</Typography>
                <CustomTextField
                  fullWidth
                  value={email}
                  onChange={handleEmailChange}
                  required
                />
              </Grid>
              <Grid item xs={4}>
                <Typography variant='body2' sx={{ margin: '1rem', fontWeight: 'bold' }}>MOT DE PASSE</Typography>
                <CustomTextField
                  fullWidth
                  type="password"
                  value={password}
                  onChange={handlePassword}
                  required
                />
              </Grid>
              <Grid item xs={0.5}>
              </Grid>
              <Grid item xs={4}>
                <Typography variant='body2' sx={{ margin: '1rem', fontWeight: 'bold' }}>COMFIRMER MOT DE PASSE</Typography>
                <CustomTextField
                  fullWidth
                  type="password"
                  value={confirmPassword}
                  onChange={handleConfirmPassword}
                  required
                />
              </Grid>
              <Grid item xs={4}>
                <Typography variant='body2' sx={{ margin: '1rem', fontWeight: 'bold' }}>PROFIL</Typography>
                <CustomFormControl fullWidth>
                  <Select value={profile} onChange={handleSelectChange}>
                    <MenuItem value="Première année">Première année</MenuItem>
                    <MenuItem value="Deuxième année">Deuxième année</MenuItem>
                    <MenuItem value="Césurier">Césurier</MenuItem>
                    <MenuItem value="Troisième Année">Troisième année</MenuItem>
                    <MenuItem value="Alumni">Alumni</MenuItem>
                    <MenuItem value="Autre">Autre</MenuItem>
                  </Select>
                </CustomFormControl>
              </Grid>
              <Grid item xs={0.5}>
              </Grid>
              <Grid item xs={4}>
                <Typography variant='body2' sx={{ margin: '1rem', fontWeight: 'bold' }}>FORMAT</Typography>
                <CustomFormControl fullWidth>
                  <Select value={format} onChange={handleFormatChange}>
                    <MenuItem value="Sport le matin">Sport le matin</MenuItem>
                    <MenuItem value="Sport après-midi">Sport l'après-midi</MenuItem>
                    <MenuItem value="Journée Entière">Journée entière</MenuItem>
                  </Select>
                </CustomFormControl>
              </Grid>
              {format === "Sport le matin" && (
                <Grid item xs={4}>
                  <Typography variant='body2' sx={{ margin: '1rem', fontWeight: 'bold' }}>SPORT</Typography>
                  <CustomFormControl fullWidth>
                    <Select value={sport} onChange={handleSportChange}>
                      <MenuItem value="Handball">Handball</MenuItem>
                      <MenuItem value="Cross 5km">Cross 5km</MenuItem>
                      <MenuItem value="Cross 10km">Cross 10km</MenuItem>
                      <MenuItem value="Volley">Volley</MenuItem>
                      <MenuItem value="Escalade">Escalade</MenuItem>
                      <MenuItem value="Tennis de Table">Tennis de Table</MenuItem>
                      <MenuItem value="Football">Football</MenuItem>
                      <MenuItem value="Rugby">Rugby</MenuItem>
                      <MenuItem value="Golf">Golf</MenuItem>
                      <MenuItem value="MiniGolf">Mini Golf</MenuItem>

                    </Select>
                  </CustomFormControl>
                </Grid>
              )}
              {format === "Sport après-midi" && (
                <Grid item xs={4}>
                  <Typography variant='body2' sx={{ margin: '1rem', fontWeight: 'bold' }}>SPORT</Typography>
                  <CustomFormControl fullWidth>
                    <Select value={sport2} onChange={handleSport2Change}>
                      <MenuItem value="Basket">Basket</MenuItem>
                      <MenuItem value="Molky">Molky</MenuItem>
                      <MenuItem value="Tennis de Table">Tennis de Table</MenuItem>
                      <MenuItem value="Pétanque">Pétanque</MenuItem>
                      <MenuItem value="Tennis">Tennis</MenuItem>
                      <MenuItem value="Beach Volley">Beach Volley</MenuItem>
                      <MenuItem value="Escalade">Escalade</MenuItem>
                      <MenuItem value="Badminton">Badminton</MenuItem>
                      <MenuItem value="Spikeball">Spikeball</MenuItem>
                      <MenuItem value="Hockey">Hockey</MenuItem>
                    </Select>
                  </CustomFormControl>
                </Grid>
              )}
              {format === 'Journée Entière' && (
                <Grid item xs={10} sx={{ display: 'flex', flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                  <Box sx={{ width: '38%' }}>
                    <Typography variant='body2' sx={{ margin: '1rem', fontWeight: 'bold' }}>SPORT MATIN</Typography>
                    <CustomFormControl fullWidth sx={{ mb: 2 }}>
                      <Select value={sport} onChange={handleSportChange}>
                        <MenuItem value="Handball">Handball</MenuItem>
                        <MenuItem value="Cross 5km">Cross 5km</MenuItem>
                        <MenuItem value="Cross 10km">Cross 10km</MenuItem>
                        <MenuItem value="Volley">Volley</MenuItem>
                        <MenuItem value="Escalade">Escalade</MenuItem>
                        <MenuItem value="Tennis de Table">Tennis de Table</MenuItem>
                        <MenuItem value="Football">Football</MenuItem>
                        <MenuItem value="Rugby">Rugby</MenuItem>
                        <MenuItem value="Golf">Golf</MenuItem>
                        <MenuItem value="MiniGolf">Mini Golf</MenuItem>
                      </Select>
                    </CustomFormControl>
                  </Box>
                  <Box sx={{ width: '38%' }}>
                    <Typography variant='body2' sx={{ margin: '1rem', fontWeight: 'bold' }}>SPORT APRÈS-MIDI</Typography>
                    <CustomFormControl fullWidth>
                      <Select value={sport2} onChange={handleSport2Change}>
                        <MenuItem value="Basket">Basket</MenuItem>
                        <MenuItem value="Molky">Molky</MenuItem>
                        <MenuItem value="Tennis de Table">Tennis de Table</MenuItem>
                        <MenuItem value="Pétanque">Pétanque</MenuItem>
                        <MenuItem value="Tennis">Tennis</MenuItem>
                        <MenuItem value="Beach Volley">Beach Volley</MenuItem>
                        <MenuItem value="Escalade">Escalade</MenuItem>
                        <MenuItem value="Badminton">Badminton</MenuItem>
                        <MenuItem value="Spikeball">Spikeball</MenuItem>
                        <MenuItem value="Hockey">Hockey</MenuItem>
                      </Select>
                    </CustomFormControl>
                  </Box>
                </Grid>
              )}
              <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center',marginBottom:'2rem' }}>
                <Button
                  sx={{
                    backgroundColor: '#96013C',
                    color: 'white',
                    padding: '10px 35px',
                    borderRadius: '20px',
                    fontWeight: 'bold',
                    marginTop: '1rem',
                    '&:hover': {
                      backgroundColor: '#96013C',
                    },
                  }}
                  type="submit">
                  S'INSCRIRE
                </Button>
              </Grid>
            </Grid>
          </Box>
        </form>
      </Box>
    </Box>
  );
}

export default Signup;
